export default {
  state: {
    tcVariables: {
      foo: 'bar'
    }
  }
};